<template>
    <kiosk-layout formContainer>
        <page-loading v-if="loading"></page-loading>
        <div v-else>
            <page-header class="mb-6 lg:mb-12">
                <template v-slot:subtitle>
                    <a href="/kiosk/users" class="no-underline! text-sky-600! text-base font-normal">
                        <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                        Search
                    </a>
                </template>

                {{ user.name }}

                <template v-slot:actions>
                    <vx-button
                        color="primary"
                        @click="impersonate()"
                        :disabled="props.userId === currentUserId || user.isUsingSingleSignOn"
                    >
                        Impersonate <font-awesome-icon widthAuto :icon="faMasksTheater"></font-awesome-icon>
                    </vx-button>
                </template>
            </page-header>

            <div class="grid grid-cols-12">
                <page-sidebar
                    :links="[
                        { href: `/kiosk/users/${props.userId}`, label: 'Details' },
                        { href: `/kiosk/users/${props.userId}/teams`, label: 'Teams' },
                    ]"
                ></page-sidebar>

                <slot></slot>
            </div>
        </div>
    </kiosk-layout>
</template>

<script setup>
import { faArrowLeft, faMasksTheater } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onMounted } from 'vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { useUserDetails } from '../composables/useUserDetails';
import { VxButton, VxSwal } from '@voxie/frontend-components';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';

const props = defineProps({
    userId: {
        type: Number,
        required: true,
    },
});

const { mount, user, loading } = useUserDetails();
const currentUserId = Spark.state.user.id;

onMounted(() => {
    mount(props.userId);
});

const impersonate = () => {
    if (user.value.current_team_id !== null) {
        window.location.assign('/spark/kiosk/users/impersonate/' + props.userId);
    } else {
        VxSwal.fire({
            icon: 'warning',
            title: 'Not a team member',
            html: 'It is not possible to impersonate a user that is a member of no teams.',
            confirmButtonText: 'Ok',
            showCancelButton: false,
        });
    }
};
</script>
